module.exports = __webpack_public_path__ + "img/img_qf_brand.f0f6dfee.png";